import classNames from 'classnames'
import { Size } from '@opallabs/gem'
import { Icon } from '@opallabs/lapidary'
import * as styles from './styles'

export { selectors as calendarFilterButtonSelectors } from './styles'

export type CalendarFilterButtonProps = Readonly<{
  /** How many filter values are applied. Zero hides the counter. */
  count: number
  /** Whether the filters are on show. */
  isOpen: boolean
  onToggle: () => void
}>

/**
 * Opens the filters and says how many are applied. Every timescale draws this
 * one, so the control bar reads the same whichever it is showing.
 *
 * It is drawn by hand rather than as a lapidary `Button`: the design gives it a
 * tinted face and a hairline of its own on hover and while active, which the
 * Button's overlays cannot be told to draw.
 */
export const CalendarFilterButton: React.FC<CalendarFilterButtonProps> = ({
  count,
  isOpen,
  onToggle,
}) => (
  <button
    aria-expanded={isOpen}
    aria-label={count === 0 ? 'Filter' : `Filter, ${count} applied`}
    aria-pressed={isOpen}
    className={classNames(styles.selectors.root, {
      [styles.states.active]: isOpen || count > 0,
    })}
    css={styles.root}
    name="toggle-filters"
    onClick={onToggle}
    type="button"
  >
    <Icon ariaHidden={true} glyph="gem-filter" size={Size.Icon} />
    <span className={styles.selectors.label}>Filter</span>
    {count > 0 && (
      <span aria-hidden={true} className={styles.selectors.counter}>
        {count}
      </span>
    )}
  </button>
)
